import { configureStore, combineReducers } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import activityReducer from "../slice/activitySlice";
import jobReducer from "../slice/jobSlice";
import userReducer from "../slice/userSlice";
import offersReducer from "../slice/offersSlice";

const persistConfig = {
  key: "teenzania",
  storage: storage,
  whitelist: ["User", "offers"],
  blacklist: [],
};

const rootReducer = combineReducers({
  activity: activityReducer,
  job: jobReducer,
  user: userReducer,
  offers: offersReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middlewareConfigs = {
  serializableCheck: {
    ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
  },
};

const Store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(middlewareConfigs),
});

const PersistedStore = persistStore(Store);
export { Store, PersistedStore };
